/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react';
import clsx from 'clsx';
import Text from '../Text/Text';
import './PharmaList.css';
import PharmaItem from './PharmaItem.js';

const PharmaList = ({
  pharmacies,
  className,
  selectedPharmacy,
  setSelectedPharmacy,
}) => {
  useEffect(() => {
    if (typeof window !== 'undefined') {
      const element = document.getElementsByClassName(
        'PharmaItem--selected'
      )[0];
      if (element) {
        element.parentNode.scroll({
          top: element.offsetTop - element.parentNode.offsetTop,
          behavior: 'smooth',
        });
      }
    }
  }, [selectedPharmacy]);

  return (
    <div className={clsx('PharmaList', { [className]: className })}>
      {pharmacies.length === 0 ? (
        <Text className="PharmaList__no-results">
          Aucun résultat trouvé pour votre recherche
        </Text>
      ) : (
        pharmacies.map((pharmacy, index) => {
          return (
            <PharmaItem
              key={index}
              selectedPharmacy={selectedPharmacy}
              setSelectedPharmacy={setSelectedPharmacy}
              pharmacy={pharmacy}
            />
          );
        })
      )}
    </div>
  );
};

export default PharmaList;
